Model = require 'models/base/model'
Collection = require 'models/base/collection'

class Group extends Model
  idAttribute: 'groupLocationId'

module.exports = class GroupCollection extends Collection
  url: '/api/pronto/groups'
  model: Group
